<template>
  <div class="banner-wrapper">
    <!-- Header 组件 -->
    <AppHeader />

    <div class="banner-container">
      <!-- 视频背景 -->
      <video ref="bannerVideo" class="banner-video" autoplay muted loop playsinline
        poster="http://www.healthcode.com/assets/images-next/hero-poster.webp">
        <source src="http://www.healthcode.com/assets/videos/hero-en.mp4" type="video/mp4" />
        <source src="http://www.healthcode.com/assets/videos/hero-en.mp4" type="video/webm" />
        您的浏览器不支持视频播放。
      </video>

      <!-- 视频遮罩层 -->
      <div class="video-overlay"></div>

      <!-- 内容区域 -->
      <div class="banner-content">
        <div class="text-content">
          <h1 class="main-title">
            {{ t("header.bannerText") }}
          </h1>
        </div>

        <!-- 可点击图标 -->
        <div class="scroll-down-icon" @click="scrollToNextSection">
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="white" viewBox="0 0 16 16">
            <path fill-rule="evenodd"
              d="M1.553 6.776a.5.5 0 0 1 .707 0L8 11.443l5.74-5.667a.5.5 0 0 1 .707.708l-6 6a.5.5 0 0 1-.707 0l-6-6a.5.5 0 0 1 0-.708z" />
          </svg>
        </div>
      </div>
    </div>
  </div>
  <Content />
  <DnaSystem />
  <Reactor100 />
  <Product />
  <SweetProtein/>
    <PeBeautie/>
  <ProductAgriculter/>
  <CoreMidea />
  <Scrollow />
  <Technology />
  <News />
  <CareerBanner />

  <Bottom/>
</template>

<script>
import AppHeader from "@/components/Header.vue";
import AppFooter from '@/components/Footer.vue';
import Bottom from '@/components/Bottom.vue';
import Content from "@/views/home/Content.vue";
import DnaSystem from "@/views/home/DnaSystem.vue";
import Scrollow from "@/views/home/Scrollow.vue";
import Product from "@/views/home/Product.vue";
import Technology from "@/views/home/Technology.vue";
import News from "@/views/home/News.vue";
import CareerBanner from "@/views/home/CareerBanner.vue";
import Reactor100 from "@/views/home/Reactor100.vue";
import CoreMidea from "@/views/home/CoreMedical.vue";
import ProductAgriculter from "@/views/home/ProductAgriculture.vue";
import SweetProtein from "@/views/home/SweetProtein.vue";
import PeBeautie from "@/views/home/PeBeautie.vue";
import { useI18n } from "vue-i18n";

export default {
  name: "Banner",
  components: {
    AppHeader,
    Content,
    DnaSystem,
    Product,
    SweetProtein,
    PeBeautie,
    ProductAgriculter,
    Scrollow,
    Technology,
    News,
    CareerBanner,
    Reactor100,
    CoreMidea,
    Bottom
  },
  setup() {
    const { t } = useI18n();

    return {
      t,
    };
  },
  methods: {
    scrollToNextSection() {
      // 向下滚动到下一个部分
      window.scrollTo({
        top: window.innerHeight,
        behavior: "smooth",
      });
    },
  },
  mounted() {
    // 确保视频在移动设备上可以自动播放
    const video = this.$refs.bannerVideo;
    if (video) {
      // 在某些移动设备上需要用户交互后才能播放
      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch((error) => {
          console.log("视频自动播放被阻止:", error);
        });
      }
    }
  },
};
</script>

<style scoped>
.banner-wrapper {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.banner-container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.banner-video {
  position: absolute;
  top: 50%;
  left: 50%;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  transform: translate(-50%, -50%);
  object-fit: cover;
  z-index: -1;
}

.video-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  z-index: 1;
}

.banner-content {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: white;
  z-index: 2;
  padding: 0 20px;
}

.text-content {
  max-width: 900px;
  margin-bottom: 60px;
}

.main-title {
  font-size: 3.6rem;
  font-weight: 500;
  line-height: 1.3;
  margin-bottom: 20px;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
  position: absolute;
  bottom: 2rem;
  left: 5rem;
  text-align: left;
  width: 55%;
}

.sub-title {
  font-size: 1.5rem;
  font-weight: normal;
  line-height: 1.5;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
}

.scroll-down-icon {
  position: absolute;
  bottom: 40px;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  animation: bounce 2s infinite;
  z-index: 3;
}

@keyframes bounce {

  0%,
  20%,
  50%,
  80%,
  100% {
    transform: translateY(0);
  }

  40% {
    transform: translateY(-20px);
  }

  60% {
    transform: translateY(-10px);
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .main-title {
    font-size: 2.5rem;
    width: 90%;
    left: 1rem
  }

  .sub-title {
    font-size: 1.2rem;
  }

  .text-content {
    margin-bottom: 40px;
  }
}

@media (max-width: 480px) {
  .main-title {
    font-size: 2.5rem;
    width: 90%;
    left: 1rem
  }

  .sub-title {
    font-size: 1rem;
  }
}

.home-job {}
</style>
